"use client";
import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useTracking } from "react-tracking";
import { SpaceLg, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
import { ProductTileCarouselClient } from "../ProductTileCarousel/ProductTileCarouselClient.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useAdobe } from "../../../../hooks/useAdobe/index.js";
const ProductAdSet = ({
  entry,
  locale,
  titleProps,
  maxSlides,
  maxSlidesBySize,
  productTileSx,
  carouselContainerSx,
  keyword,
  sx = {},
  contextData,
  isProductDetailsPage
}) => {
  var _a, _b;
  const { trackEvent } = useTracking();
  const { adobeProductsResponse } = useAdobe(entry, keyword, contextData);
  const itemNumbers = useMemo(() => {
    var _a2;
    return (_a2 = adobeProductsResponse == null ? void 0 : adobeProductsResponse.products) == null ? void 0 : _a2.map(({ id }) => id);
  }, [adobeProductsResponse == null ? void 0 : adobeProductsResponse.products]);
  if (!entry || (adobeProductsResponse == null ? void 0 : adobeProductsResponse.products.length) === 0) {
    return null;
  }
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = entry.product_display_style;
  const newTitleProps = {
    ...titleProps
  };
  if (contextData && contextData["category_title"]) {
    newTitleProps.title = (_a = titleProps == null ? void 0 : titleProps.title) == null ? void 0 : _a.replace(
      "{{category_title}}",
      contextData["category_title"]
    );
  }
  const adobeCarouselAnalytics = {
    onCarouselViewed: () => {
      trackEvent({
        trackedData: {
          ...adobeProductsResponse.adobeMeta,
          ...adobeProductsResponse.adobeOnImpr
        },
        trackType: "object"
      });
    },
    onTileClicked: (itemNumber) => {
      var _a2;
      trackEvent({
        trackedData: {
          ...adobeProductsResponse.adobeMeta,
          ...(_a2 = adobeProductsResponse.products.find(
            ({ id }) => id === itemNumber
          )) == null ? void 0 : _a2.adobeOnClick
        },
        trackType: "object"
      });
    },
    viewThreshold: 0.75
  };
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        width: isProductDetailsPage ? "100%" : `calc(100% - ${SpaceLg})`
      },
      children: /* @__PURE__ */ jsx(
        ProductTileCarouselClient,
        {
          analytics: adobeCarouselAnalytics,
          containerSx: carouselContainerSx,
          dataPrivate: (_b = entry.enable_url_tracking) == null ? void 0 : _b.disable_third_party_tracking,
          inventoryAware: inventory_aware_listings,
          isProductDetailsPage,
          itemNumbers,
          locale,
          maxSlides,
          maxSlidesBySize,
          pageType: void 0,
          productTileContainerSx: {
            backgroundColor: ColorWhite,
            borderRadius: 2,
            minHeight: "100%",
            padding: 2
          },
          productTileSx,
          showActionButton: show_action_button,
          showReviews: show_reviews,
          sx,
          testId: "Adobe_Products",
          titleProps: newTitleProps,
          variant: product_card_display_style,
          product_tile_data_source,
          wrapAround: isProductDetailsPage ? false : void 0,
          ...isProductDetailsPage && { peekAdjacent: "1rem" },
          ...isProductDetailsPage && { wrapAround: false }
        }
      )
    }
  );
};
export {
  ProductAdSet
};
